import { STORES_SET } from '../actionConstants';

export const actionSetStores = stores => ({
  type: STORES_SET,
  payload: { stores },
});
